function veda_fn_b08d7d9e13d64683bf29fadb7299f428 () {
        
  if (window.veda_fn_b08d7d9e13d64683bf29fadb7299f428Cleanup === undefined) {
    window.veda_fn_b08d7d9e13d64683bf29fadb7299f428Cleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_b08d7d9e13d64683bf29fadb7299f428Cleanup.cleanup();

        try {
          const uniqueIds = ["id_8c8656b2-a882-4885-b48e-026cb9b78ec8","id_8f487d4d-556e-42c8-a103-b29c154f4751"];
          uniqueIds.forEach(uniqueId => {
            const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
            containers.forEach(container => {
              if (!container) {
                return;
              }
              veda.plugins.videoCover(container);
              
            });
          });
        } catch(error) {
          console.error(error);
        }
      }
veda_fn_b08d7d9e13d64683bf29fadb7299f428();